import type { z } from "zod/v4";
import {
	type createLeagueSchema,
	leagueListResponseSchema,
	leagueSchema,
	type renameLeagueSchema,
} from "../../schemas/leagues";
import { fetchApi, fetchVoid } from "../internal";

export const leagues = {
	archive: (id: string) => fetchVoid(`/leagues/${id}/archive`, { method: "POST" }),
	create: (clubId: string, data: z.infer<typeof createLeagueSchema>) =>
		fetchApi(`/clubs/${clubId}/leagues`, leagueSchema, {
			body: JSON.stringify(data),
			method: "POST",
		}),
	get: (id: string) => fetchApi(`/leagues/${id}`, leagueSchema),
	list: (clubId: string, status?: "active" | "archived") => {
		const searchParams = new URLSearchParams();
		if (status) searchParams.set("status", status);
		const qs = searchParams.toString();
		return fetchApi(`/clubs/${clubId}/leagues${qs ? `?${qs}` : ""}`, leagueListResponseSchema);
	},
	rename: (id: string, data: z.infer<typeof renameLeagueSchema>) =>
		fetchApi(`/leagues/${id}`, leagueSchema, {
			body: JSON.stringify(data),
			method: "PUT",
		}),
};
